
import moment from 'moment';


// eslint-disable-next-line import/prefer-default-export
export function formatUTCLocalDate(utcDatetime, fmt = 'LL') {
  if (fmt === 'LL') {
    return moment(utcDatetime).format('YYYY-MM-DD');
  }
  return moment(utcDatetime).format('YYYY-MM-DD hh:mm:ss');
}
